import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared/index';

import { InvitationsRouting } from './invitations.routing';
import { AcceptInvitationDialogComponent } from './invitations/accept-invitation-dialog/accept-invitation-dialog.component';
import { InvitationComponent } from './invitations/invitation/invitation.component';
import { InvitationsComponent } from './invitations/invitations.component';
import { NewInvitationCreatedComponent } from './invitations/new-invitation-created/new-invitation-created.component';
import { NewInvitationFormComponent } from './invitations/new-invitation-form/new-invitation-form.component';
import { NewInvitationComponent } from './invitations/new-invitation/new-invitation.component';
import { NewInvitationErrorPipe } from './pipes/new-invitation-error.pipe';
import { RemainingPipe } from './pipes/remaining.pipe';
import { CommercialInvitationComponent } from './invitations/commercial-invitation/commercial-invitation.component';
import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';

@NgModule({
  imports: [
    SharedDependenciesModule,
    InvitationComponent,
    CommercialInvitationComponent,
    RemainingPipe,
    InvitationsRouting,
    ViDswFooterComponent,
  ],
  declarations: [
    InvitationsComponent,
    NewInvitationComponent,
    NewInvitationFormComponent,
    NewInvitationCreatedComponent,
    NewInvitationErrorPipe,
    AcceptInvitationDialogComponent,
  ],
})
export class InvitationsModule {}
